// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"548":"35c10495","728":"3d4a036e"}[chunkId] + ".chunk.css";
};